<template lang="pug">
  .login
    form(@submit="onSubmit")
      .card-login
        center
          img(src="../../../public/DA_azul.svg" style="width: 150px")
        .subtitle 
         <br> ¡Bienvenido! 
          <br>Por favor inicia sesión con tus credenciales
        small.text-danger(v-if="errors.invalidCredentials") Correo o contraseña inválido
        .form-group 
          <span>
            b-icon(icon="envelope")
          </span>
          input(type="email" :value="form.email" @input="(e)=>{form.email=e.target.value}" autocomplete required placeholder="Correo").form-control 
        .form-group
          <span>
            b-icon(icon="lock")
          </span>
          input(type="password" :value="form.password" @input="(e)=>{form.password=e.target.value}" autocomplete required placeholder="Password").form-control
        center
          p
            router-link(:to="{ name: 'Recover password' }") ¿Olvidaste tu contraseña?
        center
          b-button.boton(type="submit" variant="secondary") Ingresar
</template>

<script>
import { mapActions } from 'vuex'

export default { 
  data () {
    return {
      form: {
        email: '',
        password: ''
      },
      errors: {
        invalidCredentials: false
      }
    }
  },
  methods: {
    ...mapActions('AuthenticationStore', ['login']),
    async onSubmit (event) {
      event.preventDefault()
      const response = await this.login(this.form)
      if (!response) {
        this.errors.invalidCredentials = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .subtitle{
    color:#7F828F;
    text-align:center;
    font-size: 14px;;
    margin-bottom: 30px;
  }
  span{
  position: absolute;
  margin-left: 15px;
  height: 50px;
  display: flex;
  align-items: center;
  }
  input{
    padding-left: 35px;
    height: 50px;
  }
  .boton{
    margin:12px
  }
</style>